export default __webpack_public_path__ + "static/media/bs5-illustrations.54fdef90.svg";